import React from "react";
import "./index.css";
import { Link } from "react-router-dom";
import { useCan } from "../../utils/permissions";
const Footer = () => {
  const can = useCan();
  const canReadUser = can("user", "read");
  const canReadTask = can("task", "read");
  const canReadAppointment = can("appointment", "read");
  const canReadWorkOrder = can("workOrders", "read");
  const canReadnotification = can("notification", "read");
  return (
    <div className="hfooter">
      <div style={{ display: "flex", alignItems: "flex-end" }}>
      Pronto Copyright {new Date().getFullYear()}
      </div>
      <div className="fflex">
        <div className="itemf">   
          <Link
            to="/dashboard"
            style={{ textDecoration: "none", color: "#e6ebf3" }}
          >
            <div>Dashboard</div>
          </Link>
          {canReadnotification  &&
          <Link
            to="/update"
            style={{ textDecoration: "none", color: "#e6ebf3" }}
          >
            <div>Updates</div>
          </Link>
          }
          <Link
            to="/profile"
            style={{ textDecoration: "none", color: "#e6ebf3" }}
          >
            <div>Profile</div>
          </Link>
        </div>
        <div className="itemf">
          {canReadWorkOrder &&
          <Link
            to="/work-order"
            style={{ textDecoration: "none", color: "#e6ebf3" }}
          >
            <div>Work Orders</div>
          </Link>
          }
          {canReadAppointment &&
          <Link
            to="/appointments"
            style={{ textDecoration: "none", color: "#e6ebf3" }}
          >
            <div>Appointment </div>
          </Link>
          }
          {canReadTask &&
          <Link
            to="/survey-results"
            style={{ textDecoration: "none", color: "#e6ebf3" }}
          >
            <div>Survey Results</div>
          </Link>
          }
          {canReadUser &&
          <Link
            to="/technicians"
            style={{ textDecoration: "none", color: "#e6ebf3" }}
          >
            <div>Technicians</div>
          </Link>
          }
        </div>
      </div>
    </div>
  );
};

export default Footer;
